import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { OrdersService, PurchasesService, SupplierService } from 'src/app/msp-api/services';
import { CustomBookingDTO, Order } from '../models/global.model';


@Injectable({
	providedIn: 'root'
})
export class MspApiService {

	constructor(
		private ordersService: OrdersService,
		private purchasesService: PurchasesService,
		private supplierService: SupplierService
	) {
	}

	createPurchasePaymentIntent(id: number, type): Observable<any> {
		console.log(id, type);
		if (!id) {
			throwError('Purchase Id is required');
		}
		return this.purchasesService.purchasesStartPayment({
			id,
			body: { payment_method: type }
		});
	}

	pingPayment(id: number) {
		return this.purchasesService.purchasesConfirmPayment({ id });
	}

	getOrdersBySharedList(idList: number[], bookingsList: Array<CustomBookingDTO>) {
		return this.supplierService.supplierRetrieve()
			.pipe(
				catchError(err => of(err ? false : true)),
				switchMap((supplier) => {
					if (supplier) {
						return this.ordersService.ordersList({ vlocker_share_id: idList }).pipe(mergeMap((res) => {
							return this.supplierService.supplierOrdersList({ vlocker_share_id: idList }).pipe(map((res2) => {
								return [...res, ...res2];
							}));
						}));
					} else {
						return this.ordersService.ordersList({ vlocker_share_id: idList });
					}
				}),
				tap((orders: Array<any>) => {
					orders.forEach(ord => {
						const found = bookingsList.find(b => b.shareId === ord.vlocker_share_id);
						if (found) {
							const price = ord.order_products
								.map(p => parseFloat(p.product.price) * p.items_count)
								.reduce((val, acc) => val + acc, 0);

							const itemsCount = ord.order_products
								.reduce((val, acc) => val + acc.items_count, 0);
							const order: Order = {
								id: ord.id,
								amount: price,
								productItems: itemsCount,
								supplier: ord.supplier_name
							};
							found.order = order;
							found.orderId = order.id;
						}
					});
				})
			);
	}
}
